import React from "react";

function UpgradeButton({ title, className, ariaLabel }) {
  function dispatchCustomEvent(el, name, detail = {}) {
    el.dispatchEvent(
      new CustomEvent(name, {
        detail,
        bubbles: true,
        composed: true,
        cancelable: true,
      })
    );
  }
  return (
    <button
      {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
      onClick={() =>
        dispatchCustomEvent(window, "open-modal", "upgrade-plan-modal")
      }
      className={`btn-solid bg-yellow-500 hover:bg-yellow-600 text-yellow-900 sm:text-base ${className}`}
    >
      {title}
    </button>
  );
}

export default UpgradeButton;
